export const SET_LOGGED_USER = 'AUTH/SET_LOGGED_USER'
